import { useEffect, useState } from "react";
import { getAuthUser } from "../../lib/auth";
import { ROL_IDS } from "../constants/user";

const useProfile = () => {
  const userProfileSession = getAuthUser();
  const token = userProfileSession && userProfileSession["token"];
  const [loading, setLoading] = useState(!userProfileSession);
  const [userProfile, setUserProfile] = useState(
    userProfileSession ? userProfileSession : null
  );

  useEffect(() => {
    const userProfileSession = getAuthUser();
    setUserProfile(userProfileSession ? userProfileSession : null);
    setLoading(false);
  }, []);


  const isAdmin = userProfile?.roles?.some((r: any) => r.id === ROL_IDS.ADMIN) ?? false;
  const isUser = userProfile?.roles?.some((r: any) => r.id === ROL_IDS.USER) ?? false;

  return { userProfile, loading, token, isAdmin, isUser };
};

export { useProfile };
